export const ROLE_IDS = {
  ADMIN_USER : 1,
  HO_LEVEL_COORDINATORS : 2,
  STATE_LEVEL_COORDINATORS : 3,
  CLUSTER_LEVEL_COORDINATORS : 4,
  QUALITY_CHECKER : 5,
  CROSS_DEPARTMENT : 6,
};

export const getRole = (groups: string[]) => {
  const icvOpsGroups = groups.filter(group => 
    group.includes('/Employee Group/Crop-Watch-Ops/')
  );  
  return {
    groups: icvOpsGroups.map((group: any) => group?.replace('/Employee Group/Crop-Watch-Ops/', ''))
  };
}; 

export const getRolePermission = (tokenPayload: any) => {
  const client_name = process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? ''
  const permissions = tokenPayload?.resource_access[client_name]?.roles;
  return permissions;
}

export const hasModulePermission = (userPermissions: string[], requiredPermissions: string[], userRoleId: number, requiredRoleId: number[]): boolean => {
  // If no permissions are required for the module, allow access
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }
  
  // If user has no permissions, deny access
  if (!userPermissions || userPermissions.length === 0) {
    return false;
  }
  
  // Check if user has at least one of the required permissions and has a valid roleid in db
  return requiredPermissions.some(permission => userPermissions.includes(permission)) && (requiredRoleId?.length === 0 || requiredRoleId?.includes(userRoleId));
};